import produce from "immer";

const getDefaultState = () => {
  return [];
};

const sites = (state = getDefaultState(), action) => {
  let nextState;
  switch (action.type) {
    case "SITES_GET":
      nextState = produce(state, (draftState) => action.payload.data);
      return nextState;
    default:
      return state;
  }
};

export default sites;
